import { PaymentDueAccountVM } from "@propertelligent/client-api/models/PaymentDueAccountVM";
import "./payment.css";
import { useState } from "react";
import LargeTooltip from "../tooltips/large-tooltip";
import dateicon from "../../assets/Date.svg";
import docicon from "../../assets/Doc.svg";
import UtilHelper from "../../utils/UtilHelper";
import DateHelper from "../../utils/DateHelper";
import CurrencyTooltip from "../../components/currencytooltip/CurrencyTooltip";

interface PaymentDashboardProps {
  payments: PaymentDueAccountVM[];
  selectedPayment?: PaymentDueAccountVM;
  onPaymentSelect?: (payment: PaymentDueAccountVM) => void;
}



export default function PaymentDashboard({ payments, selectedPayment, onPaymentSelect }: PaymentDashboardProps) {
    const [tooltipState, setTooltipState] = useState<{
      isOpen: boolean;
      description: string;
      position: { top: number; left: number };
    }>({
      isOpen: false,
      description: "",
      position: { top: 0, left: 0 },
    });
  

  const handleViewMoreClick = (
    event: React.MouseEvent<HTMLAnchorElement>,
    description: string
  ) => {
    
    event.preventDefault();
    event.stopPropagation(); // Prevent triggering payment selection
    const rect = event.currentTarget.getBoundingClientRect();
    setTooltipState({
      isOpen: true,
      description,
      position: {
        top: rect.bottom + window.scrollY,
        left: rect.left + window.scrollX,
      },
    });
  };

  const handleCloseTooltip = () => {
    setTooltipState((prev) => ({ ...prev, isOpen: false }));
  };



  return (
    <div className="main-container">
      <LargeTooltip
        isOpen={tooltipState.isOpen}
        onClose={handleCloseTooltip}
        description={tooltipState.description}
        position={tooltipState.position}
      />
      <div className="header-section">
        <h1 className="main-title">{payments.length} Payments</h1>
      </div>

      {payments.map((payment, index) => (
        <div key={payment.id || index}>
          <div 
            className={`payment-wrapper ${selectedPayment?.id === payment.id ? 'payment-wrapper-selected' : ''}`}
            onClick={() => onPaymentSelect?.(payment)}
            style={{ cursor: onPaymentSelect ? 'pointer' : 'default' }}
          >
            <div className="d-block">
              <h2 className="address-title">{payment?.streetAddress || "Organization"}</h2>
              <div className="info-line">
                <img
                  src={docicon}
                  alt=""
                  width={20}
                  height={20}
                  className="info-line-icon color-white-icon"
                  loading="lazy"
                />
                <span className="payment-desc">
                  {(payment.description ?? "").length > 30
                      ? `${(payment.description ?? "").slice(0, 30)}...`
                      : (payment.description ?? "")}
                    {(payment.description ?? "").length > 30 && (
                      <a
                        href="#"
                        className="listing-viewmore mx-2 ml-1 text-blue-500 underline"
                        onClick={(e) => handleViewMoreClick(e, payment.description)}
                      >
                        View more
                      </a>
                    )}
                </span>
               
              </div>

              <div className="info-line">
                <img
                  src={dateicon}
                  alt=""
                  width={20}
                  height={20}
                  className="info-line-icon color-white-icon"
                  loading="lazy"
                />
                <span className="due-text">Due on: {payment.formatted?.DueDateDateOnly}</span>
              </div>
            </div>
            <div className="amount-text">
              <CurrencyTooltip
                content={payment.formatted?.AmountRaw}
                formatted={payment.formatted?.Amount}
              >
                <span>{payment.formatted?.Amount}</span>
              </CurrencyTooltip>
            </div>
          </div>

          {index < payments.length - 1 && <div className="separator-line"></div>}
        </div>
      ))}
    </div>
  );
}